<template>
  <div class="page page--center">
    <h1 class="page__title">Личный кабинет</h1>
    <div class="cabinet">
      <ul class="cabinet__tabs">
        <li v-for="tab in tabs" class="cabinet__tab">
          <router-link :to="{ name: tab.route }" class="cabinet__tab-link" active-class="cabinet__tab-link--active">
            <fa :icon="tab.icon" fixed-width/>
            {{ tab.name }}
          </router-link>
        </li>
      </ul>

      <div class="cabinet__content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  loading: false,

  computed: {
    tabs () {
      return [
        {
          icon: 'user',
          name: 'Настройки профиля',
          route: 'settings.profile'
        },
        {
          icon: 'edit',
          name: 'Статистика',
          route: 'settings.stats'
        },
        {
          icon: 'lock',
          name: 'Сменить пароль',
          route: 'settings.password'
        }
      ]
    }
  },
  beforeMount() {
    this.$store.dispatch('pages/setBreadcrumbs', [
      {
        title: 'Главная',
        route: { name: 'home' }
      },
      {
        title: 'Настройки профиля',
      }
    ]);
  }
}
</script>

<style>
.settings-card .card-body {
  padding: 0;
}
</style>
